import React from "react";
import { useForm } from "react-hook-form";
import { OCCASION_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import AddButton_v2 from "../../../../reusable-components/buttons/AddButton_v2";
import Button from "../../../../reusable-components/buttons/Button";
import SubmitButton from "../../../../reusable-components/buttons/SubmitButton";
import Input from "../../../../reusable-components/inputs/InputTextBox/Input";
import { button, cancel_button } from "../../../../theme/lightTheme";
import showToast from "../../../../utilities/notification/NotificationModal";

const AddOccasionTypeForm = ({
  getOccasionTypeList,
  editOccasionTypeDetails,
  setEditOccasionTypeDetails,
  setShowAddForm,
}) => {
  // const axiosPrivate = useAxiosPrivate();
  // const { auth } = useAuth();

  const isEdit = Object.keys(editOccasionTypeDetails)?.length > 0;

  const defaultValues = {
    occasion_type_name: !isEdit
      ? ""
      : editOccasionTypeDetails?.occasion_type_name,
  };
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    try {
      let response = "";
      if (!isEdit) {
        // data.createdby = auth.userid;
        data.createdby = "admin";
        response = await axios.post(OCCASION_TYPE_CONFIG_URL, data);
      } else {
        // data.updatedby = auth.userid;
        data.updatedby = "admin";
        data.occasion_type_id = editOccasionTypeDetails?.occasion_type_id;
        response = await axios.post(`${OCCASION_TYPE_CONFIG_URL}/update`, data);
      }

      // console.log({ response });

      if (response.status === 200) {
        if (isEdit) {
          setEditOccasionTypeDetails({});
          showToast(
            "Occasion Type details has been updated successfully.",
            "success"
          );
        } else {
          showToast(
            "Occasion Type details has been added successfully.",
            "success"
          );
        }
        getOccasionTypeList();
      } else {
        if (isEdit) {
          console.log("Save Occasion Type Details Error:", response.data);
        } else {
          if (
            response.data.saveOccasionTypeDetails.includes(
              "unique_occasion_type"
            )
          ) {
            showToast(
              "Occasion Type already exists. Cannot insert duplicate occasion type.",
              "error"
            );
          } else {
            showToast(
              "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
              "error"
            );
          }
        }
        return;
      }
      setShowAddForm(false);
      reset();
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  return (
    <section>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          defaultName="occasion_type_name"
          register={register}
          name="Occasion Type Name"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter occasion type name"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="text"
          classes={`rounded-lg px-3 py-2 text-sm w-full focus:outline-none focus:ring-0 focus:border-2 focus:border-black`}
          onChangeInput={null}
          defaultValue={defaultValues.occasion_type_name}
          setValue={setValue}
        />
        <div className="flex justify-between">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={!isEdit ? "Submit" : "Update"}
            className={button}
          />
          <Button
            onClick={() => {
              setEditOccasionTypeDetails({});
              setValue("occasion_type_name", "");
              setShowAddForm(false);
            }}
            aria-label="Cancel Occasion Type Update Button"
            className={cancel_button}
          >
            Cancel
          </Button>
        </div>
      </form>
    </section>
  );
};

export default AddOccasionTypeForm;
